import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";

const inital = {
  data: null
};

export const orgSlice = createSlice({
  name: "org",
  initialState: inital,
  reducers: {
    setOrg: (state, action) =>{
      const org = action.payload;
      state.data = org;
    },
    clearOrg: (state, action) => {
      state.data = null;
    },
  },
});

export const { actions: orgActions, reducer: orgReducer } = orgSlice;